import { Box, Icon, IconName } from '@talos/kyoko';
import { NavLink } from 'react-router-dom';
import type { NavigationItem } from '../../../tokens/navigationPaths';
import { TAB_BUTTON_SIZE, TabButtonWrapper } from './styles';

interface TabButtonProps {
  item: NavigationItem;
  isSelected: boolean;
  onPress?: () => void;
}

export function TabButton({ item, isSelected, onPress }: TabButtonProps) {
  const content = (
    <TabButtonWrapper isSelected={!!isSelected}>
      <Icon size={24} thin icon={item.icon ?? IconName.Table} />
      <Box pt="spacingSmall" fontSize={10 / 16} data-testid={getTabLabelTestId(item)}>
        {item.label}
      </Box>
    </TabButtonWrapper>
  );

  if (item.path == null) {
    return (
      <button type="button" onClick={onPress} style={TAB_BUTTON_STYLE}>
        {content}
      </button>
    );
  }

  return (
    <NavLink key={item.id} to={item.path} onClick={onPress} style={TAB_BUTTON_STYLE}>
      {content}
    </NavLink>
  );
}

const TAB_BUTTON_STYLE = { height: TAB_BUTTON_SIZE, border: 'none', flex: 1, background: 'transparent', padding: 0 };

function getTabLabelTestId(item: NavigationItem) {
  return `mobile-tab-label-${item.id ?? item.path ?? ''}`;
}
